<template>
  <modal
    :focus-trap="true"
    :scrollable="false"
    :draggable="true"
    :adaptive="true"
    :reset="true"
    :click-to-close="false"
    :shift-x="0.98"
    :shift-y="0.8"
    width="400px"
    height="auto"
    name="outgoing-call-modal"
    styles="border-radius: 20px; right: 90; bottom: 0; background-color: #131c25; pointer-events: auto !important;"
    @opened="onOpened"
    @before-open="onBeforeOpen"
    @before-close="onBeforeClose"
  >
    <div class="d-flex flex-column p-3 justify-content-between align-items-center h-100" style="gap: 5px; min-height: 300px;">
      <b-avatar
        :src="getValueFromSource(patient, 'avatar.path')"
        :text="(avatarText(getValueFromSource(patient, 'full_name')))"
        variant="light-danger"
        size="70"
      />

      <div>
        <h3 class="text-white">{{ getValueFromSource(patient, 'full_name') }}</h3>
        <div class="text-center">{{ connectionMessage }}</div>
      </div>
      <div class="d-flex w-100 justify-content-center" style="gap: 15px;">
        <b-button variant="danger" pill @click="endOutgoingVideoCall()">
          <feather-icon color="white" icon="PhoneOffIcon" />
          End Call
        </b-button>
      </div>
    </div>
  </modal>
</template>

<script>
import { get, throttle } from 'lodash';
import { BAvatar, BButton } from 'bootstrap-vue';

import webRTCBus from '@core/mixins/bus/webrtc';
import WEB_RTC_ACTIONS from '@core/utils/webrtc';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

const NOT_ONLINE_NOTIFICATION_AUDIO = require('@/assets/sounds/beep.mp3')
const CALL_DROPPED_NOTIFICATION_AUDIO = require('@/assets/sounds/end_call.mp3')

export default {
  name: 'VideoModal',
  components: {
    BAvatar,
    BButton
  },
  data() {
    return {
      connectionMessage: 'Connecting...',
      patient: null,
      timeoutId: null,
      intervalId: null,
      consultation_id: null,
      debouncedOnlineCheckFn: null,

      callDroppedOrDialed: false,

      notOnlineTone: new Audio(NOT_ONLINE_NOTIFICATION_AUDIO),
    }
  },
  created() {
    this.debouncedOnlineCheckFn = throttle(this.checkPatientOnlineStatus, 1e3);
  },
  methods: {
    async checkPatientOnlineStatus() {
      try {
        if (this.callDroppedOrDialed) return; // early return if already dialed or dropped

        const response = await this.useJwt().mainService.patients.isOnline(this.patient.id);
        const status = get(response, 'data.data');
        console.log('ONLINE STATUS', status)
        if (status.isOnline){
          this.notOnlineTone.pause();
          this.notOnlineTone.currentTime = 0;

          clearTimeout(this.timeoutId)
          clearInterval(this.intervalId);

          this.timeoutId = null;
          this.intervalId = null;

          // emit to initiate call
          this.callDroppedOrDialed = true; // prevent further emits
          this.connectionMessage = 'Dialing...'
          webRTCBus.$emit(WEB_RTC_ACTIONS.DIAL_CALL, this.consultation_id);
        } else {
          this.notOnlineTone.play()
        }
      } catch (error){
        console.log('check patient online status error', error.message)
      }
    },
    playCallDroppedSound() {
      const audio = new Audio(CALL_DROPPED_NOTIFICATION_AUDIO)
      audio.play()
    },
    endOutgoingVideoCall() {
      console.log('END CALL TAPPED')
      webRTCBus.$emit(WEB_RTC_ACTIONS.CALL_DROPPED);
    },
    onBeforeOpen(args){
      const { patient, consultation } = args.params;
      this.patient = patient;
      this.consultation_id = consultation._id;
      webRTCBus.$emit(WEB_RTC_ACTIONS.LOCK_CALL_BUTTON, true)
    },
    onOpened() {
      this.callDroppedOrDialed = false; // reset on modal open

      this.connectionMessage = 'Connecting...';

      this.intervalId = setInterval(() => {
        this.debouncedOnlineCheckFn();
      }, 1e3);

      this.timeoutId = setTimeout(() => {
        if (this.callDroppedOrDialed) return;

        console.log("DROPPING CALL BECAUSE USER IS OFFLINE")
        // drop call after waiting 10 seconds
        clearInterval(this.intervalId);
        this.intervalId = null;
        this.callDroppedOrDialed = true;

        this.$modal.hide('outgoing-call-modal')
        this.playCallDroppedSound()

        this.$toast({
          component: ToastificationContent,
          timeout: 5000,
          props: {
            variant: 'warning',
            title: 'Call Failed!',
            icon: 'CheckCircleIcon',
            text: "Call dropped because patient is not online."
          },
        });
      }, 15e3);
    },
    onBeforeClose(){
      webRTCBus.$emit(WEB_RTC_ACTIONS.LOCK_CALL_BUTTON, false)
    },
  },
}
</script>

<style></style>
